var chunkMapping = {
	"webpack_container_remote_institution_Routes": [
		59096
	],
	"webpack_container_remote_authentication_Routes": [
		42272
	]
};
var idToExternalAndNameMapping = {
	"42272": [
		"default",
		"./Routes",
		81713
	],
	"59096": [
		"default",
		"./Routes",
		77620
	]
};
var idToRemoteMap = {
	"42272": [
		{
			"externalType": "module",
			"name": ""
		}
	],
	"59096": [
		{
			"externalType": "module",
			"name": ""
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"42272": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 81713,
		"remoteName": ""
	},
	"59096": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 77620,
		"remoteName": ""
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}